export const SET = 'session//SET'

interface SetSessionAction {
  type: typeof SET
  payload: any
}

export type SessionActions = SetSessionAction
